import React, { Component } from "react";
import ReactGA from 'react-ga';
import Link from "react-router-dom/Link";
import Page from "../Page";
import restartSVG from "img/restart.svg";
import checkout from "img/checkout.png";
import bang from "img/bang.png";

import Popup2 from "../popup/Popup2";

export default class Problem extends Component {
  constructor(props) {
    super(props);
    this.state = { showPopup: false };
  }

  showPopup = () => {
    this.setState({ showPopup: true });
  };

  render() {
    const { showPopup } = this.state;
    const { storeNumber, Transaction_Count, resetData } = this.props;
    ReactGA.pageview('/problem/2')

    return (
      <Page>
        <div className="problem-page">
          <div className="introduction-page__restart-block">
            <ul className="arrival-page__arms-list">
              <li>A</li>
              <li className="in-red">R</li>
              <li>M</li>
              <li>S</li>
            </ul>
            <Link
              to={{ pathname: "/login", state: { prev: true } }}
              className="introduction-page__restart-btn"
              href="#"
              onClick={resetData}
            >
              <img
                className="introduction-page__restart-icon"
                src={restartSVG}
                alt=""
              />
              <span>Restart</span>
            </Link>
          </div>
          <div className="problem-page__main-section">
            <div className="problem-page__investigate-block">
              <div className="problem-page__animated-block">
                <img className="problem-page__bang-circle" src={bang} alt="" />
                <h1 className="problem-page__header-text">Cashier Doesn’t Have the Code!</h1>
                <p>
                  When access to the cage is limited to only the head cashier, it
                  slows down the checkout process for everyone – especially the
                  customer!{" "}
                </p>
                <Link
                  to="/problem/2"
                  onClick={this.showPopup}
                  className="btn login-page__start-btn"
                >
                  <span>Let's investigate</span>
                </Link>
              </div>
            </div>
            <div className="problem-page__image-container">
              <img className="problem-page__image" src={checkout} alt="" />
            </div>
          </div>

          {showPopup && (
            <Popup2
              storeNumber={storeNumber}
              Transaction_Count={Transaction_Count}
            />
          )}
        </div>
      </Page>
    );
  }
}
